












































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { MobileGetter } from 'frontend/types';

interface TrialStep {
  header: string;
  strikethroughHeader: boolean;
  iconClass: string;
  completed: boolean;
  text: string;
}

@Component({
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class HowPremiumWorks extends Vue {
  public static dateOptions = { month: 'long', day: 'numeric' } as const;

  @Prop(String) private readonly nuxGoal!: string | undefined;
  @Prop(String) private readonly interestedIn!: string | undefined;
  @Prop(String) private readonly heading!: string;
  @Prop(String) private readonly subHeading!: string | undefined;
  @Prop(Number) private readonly trialLength!: number;
  @Prop({ type: Boolean, default: false }) private readonly isExperiment!: boolean;
  @Prop({ type: Boolean, default: false }) private readonly isCompact!: boolean;
  @Prop({ default: 'how_premium_works' }) private readonly testIdPrefix: string | undefined;

  private isMobile!: MobileGetter;

  private get trialSteps(): TrialStep[] {
    return [
      {
        header: this.isExperiment
          ? 'Set your professional learning goal'
          : 'Set your learning goals',
        strikethroughHeader: !this.isExperiment,
        iconClass: 'b-sprite-paywall-checkmark-black',
        completed: true,
        text: this.isExperiment
          ? 'Build skills and level up your thinking.'
          : this.stepOneTrialStepText,
      },
      {
        header: 'Today: Get Premium access',
        strikethroughHeader: false,
        iconClass: 'b-sprite-paywall-start',
        completed: true,
        text: this.isExperiment
          ? 'Full access to 60+ courses, daily motivation, and more'
          : `Full access to 70+ interactive courses, and more.`,
      },
      {
        header: `Day ${this.trialLength - 2}: Trial Reminder`,
        strikethroughHeader: false,
        iconClass: 'b-sprite-paywall-bell',
        completed: false,
        text: 'We’ll send you an email reminder about when your trial will end.',
      },
      {
        header: `Day ${this.trialLength}: Trial ends`,
        strikethroughHeader: false,
        iconClass: 'b-sprite-paywall-trial-end',
        completed: false,
        text: `You’ll be charged and your subscription will start on ${this.trialEnddate}. Cancel anytime before.`,
      },
    ];
  }

  private get formattedNuxGoal(): string | undefined {
    if (this.nuxGoal) {
      const goal = this.nuxGoal.replaceAll('*', '').toLowerCase();
      if (goal === 'get the best learning tools for my students or children') {
        return goal.replaceAll(/my/gi, 'your');
      }
      return goal;
    }
  }

  private get headingCopy(): string {
    return this.heading.replace('{TRIAL_LENGTH}', this.trialLength.toString());
  }

  private get stepOneTrialStepText(): string {
    if (this.nuxGoal === 'Other') {
      return 'You successfully created your profile and set your learning goals.';
    }
    if (this.nuxGoal && this.interestedIn) {
      return `You are looking to ${
        this.formattedNuxGoal
      } and are interested in ${this.interestedIn.toLowerCase()}.`;
    }
    if (this.nuxGoal) {
      return `You are looking to ${this.formattedNuxGoal}.`;
    }
    return 'You successfully created your profile and set your learning goals.';
  }

  private get trialEnddate() {
    const today = new Date();
    const endDate = new Date(today.getTime() + this.trialLength * 24 * 60 * 60 * 1000);
    return endDate.toLocaleDateString('en-US', HowPremiumWorks.dateOptions);
  }
}
